/* eslint-disable no-undef */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */

import React from 'react';
import advSearchState from 'Stores/advSearch';
import { observer } from 'mobx-react';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import { DropDownBox } from '../shared-component/dropDownBox';

const originalDropDownValue = [
  {
    name: '0 - 25',
    pName: '0 - 25',
    selected: false,
  },
  {
    name: '25 - 100',
    pName: '25 - 100',
    selected: false,
  },
  {
    name: '100 - 250',
    pName: '100 - 250',
    selected: false,
  },
  {
    name: '250 - 1000',
    pName: '250 - 1000',
    selected: false,
  },
  {
    name: '1K - 10K',
    pName: '1K - 10K',
    selected: false,
  },
  {
    name: '10K - 50K',
    pName: '10K - 50K',
    selected: false,
  },
  {
    name: '50K - 100K',
    pName: '50K - 100K',
    selected: false,
  },
  {
    name: '> 100K',
    pName: '> 100K',
    selected: false,
  },
];

const EmpCount = observer(props => {
  const suggestionKey = 'employeeCount';
  const blockedKey = 'empCount';
  const [showSuggestion, setShowSuggestion] = React.useState(false);
  const [suggestionList, setSuggestionList] = React.useState(
    originalDropDownValue,
  );

  // const [suggestionArr, setSuggestionArr] = React.useState([]);
  const [selectedItem, setSelectedItem] = React.useState([]);
  const [noMatchFound, setNoMatchFound] = React.useState(false);

  // const [searchKeys, setSearchKeys] = React.useState([]);

  React.useEffect(() => {
    // console.log('selectedItem ', selectedItem);
  }, [selectedItem]);
  // React.useEffect(() => {
  //   const arr = suggestionList.map(item => {
  //     return item.name;
  //   });
  //   console.log('suggestionArr ', arr);
  //   setSuggestionArr(arr);
  // }, []);
  return (
    <DropDownBox
      placeholder="Employee Count"
      showSuggestion={showSuggestion}
      setShowSuggestion={setShowSuggestion}
      suggestionList={suggestionList}
      noMatchFound={noMatchFound}
      setNoMatchFound={setNoMatchFound}
      setSelectedItem={setSelectedItem}
      suggestionKey={suggestionKey}
      originalDropDownValue={originalDropDownValue}
      setSuggestionList={setSuggestionList}
      searchBoxId="empCountSearchBox"
      blockedKey={blockedKey}
      showDropdownIcon
      {...props}
    />
  );
});

export { EmpCount };
export default EmpCount;
